import actions from './actions';
import getters from './getters';

const { steps } = {
  steps: {
    intro: {
      step: 'Form Bilgileri',
      email: null,
      fullname: null,
      phoneNumber: null,
      packageCollection: null,
      packageInfo: null,
      isMarketingAccepted: false,
      isSMS: false,
      isEmail: false,
      isCall: false,
    },
  },
};
export default {
  namespaced: true,
  state: {
    defaultSteps: steps,
    ...steps,
  },
  actions,
  getters,
};
